import { AbstractSubscriber } from './AbstractSubscriber'
import { AbstractSearchCore } from './AbstractSearchCore'
import { IMultipleResults } from './IMultipleResults'
import { IFacet } from './IFacet'
import { ISearchConfig } from './ISearchConfig'
import MainModule from '../main'
import { Routing } from '../routing'
import { Geo } from '../geo'
import { config } from '../../constants'

export class URLRegionSearchSubscriber extends AbstractSubscriber {
  private _core: AbstractSearchCore | null = null

  constructor(groupId: string) {
    super(groupId)
  }

  public async attached(core: AbstractSearchCore): Promise<void> {
    this._core = core

    let routing: Routing = MainModule.getInstance().getRouting()
    let geo: Geo | null = MainModule.getInstance().getGeo()

    if (!geo) {
      return // Gracefully skip if geo is unavailable
    }

    try {
      if (
        routing.isStringInList(
          routing.getRouteKeyFromCurrentLocation(undefined, true),
          config.regionalSearchLocation
        )
      ) {
        let urlLocation = window.location.pathname.split('/')
        let region = urlLocation[urlLocation.length - 1]

        if (region) {
          let regionObj = await geo.list(region)

          if (regionObj && regionObj.length > 0) {
            let regionFacet: IFacet = {
              name: 'touristRegion',
              options: [
                {
                  value: regionObj[0].county,
                  selected: true,
                  available: true,
                  extraData: regionObj[0],
                },
              ],
            }

            await this._core.applySearchConfig(
              {
                facets: [regionFacet],
              },
              false
            )

            this._core.goToSearch()
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {}
  async onSearchTextUpdate(text: string): Promise<void> {}
  async onFacetUpdate(facets: IFacet[]): Promise<void> {}
  async onResultUpdate(results: IMultipleResults): Promise<void> {}
  public detaching(): void {
    this._core = null
  }
}
